import React from "react"
import { Outlet } from "react-router-dom"

import { Navbar } from "../navigation/Navbar"
import { TopBar } from "../navigation/TopBar"
import { LayoutWrapper } from "./LayoutWrapper"

const AppLayout: React.FC = () => {
    return (
        <LayoutWrapper
            isDarkMode={false}
        >
            <main className="min-h-screen light">
                <div className="middle">
                    <Navbar isOpenable />
                    <TopBar />

                    <div className="app-content">
                        <Outlet />
                    </div>
                </div>
            </main>
        </LayoutWrapper>
    )
}

export default AppLayout